import { useState } from "react";
import { PageShell, PageHero } from "@project/user/components/page-shell";
import { Reveal } from "@project/user/components/reveal";
import { AdmissionSuccessDialog } from "@project/user/components/admission-success-dialog";
import { AdmissionInquiryForm } from "@project/components/admission-inquiry-form";
import { useI18n } from "@project/lib/use-i18n";

export default function AdmissionInquiryPage() {
  const { t } = useI18n();
  const [successOpen, setSuccessOpen] = useState(false);
  const [submittedSummary, setSubmittedSummary] = useState<{
    inquirerName: string;
    elderName: string;
  } | null>(null);

  const handleSuccessOpenChange = (open: boolean) => {
    setSuccessOpen(open);
    if (!open) {
      setSubmittedSummary(null);
    }
  };

  return (
    <PageShell>
      <AdmissionSuccessDialog
        open={successOpen}
        onOpenChange={handleSuccessOpenChange}
        applicantName={submittedSummary?.inquirerName}
        elderName={submittedSummary?.elderName}
      />
      <PageHero
        eyebrow={t("account.admissionInquiry.eyebrow")}
        title={t("account.admissionInquiry.title")}
        subtitle={t("account.admissionInquiry.subtitle")}
      />
      <section className="mx-auto max-w-4xl px-4 py-8 sm:py-12">
        <Reveal>
          <AdmissionInquiryForm
            mode="user"
            onSubmitted={summary => {
              setSubmittedSummary(summary);
              setSuccessOpen(true);
            }}
          />
        </Reveal>
      </section>
    </PageShell>
  );
}
